import PartnersMap from './PartnersMap';

export default PartnersMap;